import { Button } from "@mui/material";

const RefreshEntitiesCacheButton = ({ handleOnClick }) => {
  return (
    <Button
      variant="outlined"
      onClick={handleOnClick}
      sx={{ backgroundColor: "yellow" }}
    >
      Refresh Entities Cache
    </Button>
  );
};

export default RefreshEntitiesCacheButton;
